export const translations = {
  en: {
    title: 'As Seen In',
  },
  spa: {
    title: 'Visto en',
  },
};
